export class PdfViewerDialog {
  Titel: string;
  Source: string | ArrayBuffer;
  Keywords: Array<string>;
}
